// extracted by mini-css-extract-plugin
export var banner = "_23-0";
export var icon = "_23-1";
export var message = "_23-2";